import React, { useState, useEffect } from "react";

// reactstrap components
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	FormGroup,
	Form,
	Input,
	Row,
	Col,
	FormFeedback,
	Label,
	CustomInput
} from "reactstrap";
import { useHistory } from 'react-router-dom'
import useForm from "../../formValidator/userForm";

import Toaster from "../../components/Toaster";
import Loader from '../../components/Loader'

import { ROLES_MAP, STATUS_LIST, ROLES_CONSTANTS } from '../../configs/constant'
import { DISTRICTS, DEPARTMENT, USERS } from '../../configs/urls'

import { getApi, postApi, putApi } from '../../services/api'
import axios from 'axios'

const ManageUser = (props) => {

	const [pageTitle, setPageTitle] = useState('Create user')
	const [districts, setDistricts] = useState([])
	const [departments, setDepartments] = useState([])
	const [isRequesting, setIsRequestig] = useState(false);
	const isDistrictOfficer = (props.match.params.role_id == ROLES_MAP['district_officer']
		|| props.match.params.role_id == ROLES_MAP['dpm']
		|| props.match.params.role_id == ROLES_MAP['field_officer'])
	const isDepartmentOfficer = (props.match.params.role_id == ROLES_MAP['department_officer']
		|| props.match.params.role_id == ROLES_MAP['field_officer'])
	const history = useHistory()

	useEffect(() => {

		const userRole = ROLES_CONSTANTS.find(r => r.id == props.match.params.role_id)
		if (userRole) {
			if (props.match.params.user_id) {
				setPageTitle(`Update ${userRole.title}`)
			} else {
				setPageTitle(`Add New ${userRole.title}`)
			}
		}

		if (props.match && props.match.params && !props.match.params.user_id) {
			params.status = 1
		}

		getAllData()
	}, [])

	const getAllData = () => {

		setIsRequestig(true);

		let districts
		let departments
		let user

		if (props.match && props.match.params && props.match.params.user_id) {
			user = getApi(USERS + "/" + props.match.params.user_id);
			setPageTitle('Update User')
		}

		if (isDistrictOfficer) {
			districts = getApi(DISTRICTS)
		}

		if (isDepartmentOfficer) {
			departments = getApi(DEPARTMENT)
		}

		axios.all([user, districts, departments]).then(res => {
			if (res[0] && res[0].data) {
				let {
					name,
					email,
					status,
					password,
					mobile_no,
					district_id,
					department_id
				} = res[0].data;
				params.name = name;
				params.email = email;
				params.mobile_no = mobile_no;
				params.password = password;
				params.status = status;

				if (isDepartmentOfficer) {
					params.department_id = department_id;
				}

				if (isDistrictOfficer) {
					params.district_id = district_id;
				}
			}

			if (res[1] && res[1].data) {
				setDistricts(res[1].data)
			}

			if (res[2] && res[2].data) {
				setDepartments(res[2].data)
			}
		}).finally(() => {
			setIsRequestig(false);
		})
	}


	const validate = (values) => {
		let errors = {};

		if (!values.name) {
			errors.name = "Name is required.";
		}

		if (!values.password && !props.match.params.user_id) {
			errors.password = "Password is required.";
		}

		if (values.status < 0) {
			errors.status = "Please select status.";
		}

		if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
			errors.email = "Email address is invalid.";
		}

		if (values.username && !/^[\S]+$/.test(values.username)) {
			errors.username = "Please remove extra space.";
		}

		if (!values.mobile_no) {
			errors.mobile_no = "mobile_no number is required.";
		} else if (
			values.mobile_no.length < 10 ||
			!/^[0-9]/.test(values.mobile_no)
		) {
			errors.mobile_no = "Mobile number is not valid.";
		}

		if (isDepartmentOfficer && (!params.department_id || params.department_id < 0)) {
			errors.department_id = "Please select department.";
		}

		if (isDistrictOfficer && (!params.district_id || params.district_id < 0)) {
			errors.district_id = "Please select district.";
		}

		return errors;
	};

	const saveUser = () => {

		const dataParams = {
			...params,
			role_id: props.match.params.role_id
		}

		const data = new FormData();
		for (const key in dataParams) {
			data.append(key, dataParams[key]);
		}

		if (props.match && props.match.params && props.match.params.user_id) {

			putApi(`${USERS}/${props.match.params.user_id}`, data).then((res) => {
				history.goBack()
			}, () => {

			}).finally(() => {
				setIsRequestig(false);
			});
		} else {
			postApi(USERS, data).then(res => {
				Toaster.showSuccess(res.message || 'User saved successfully.')
				history.goBack()
			})
				.finally(() => {
					setIsRequestig(false);
				});
		}
	}

	const { params, errors, handleChange, handleSubmit } = useForm(
		saveUser,
		validate
	);

	return (
		<div className="content">
			<Loader isLoading={isRequesting} />
			<Row>
				<Col md="12">
					<Card className="card-user">
						<CardHeader>
							<CardTitle tag="h5">{pageTitle}</CardTitle>
						</CardHeader>
						<CardBody>
							<Form autoComplete="off" noValidate onSubmit={handleSubmit}>
								<Row>
									<Col className="pr-1" md="6">
										<FormGroup>
											<label>Name</label>
											<Input
												type="text"
												name="name"
												placeholder="Your full Name"
												value={params.name || ""}
												onChange={handleChange}
												invalid={errors.name && errors.name.length > 0 ? true : false}
											/>
											<FormFeedback>{errors.name}</FormFeedback>
										</FormGroup>
									</Col>
									{!(props.match && props.match.params && props.match.params.user_id) &&
									<Col className="pl-1" md="6">
										<FormGroup>
											<label>Username</label>
											<Input
												type="text"
												name="username"
												placeholder="Your Username"
												value={params.username || ""}
												onChange={handleChange}
												invalid={errors.username && errors.username.length > 0 ? true : false}
											/>
											<FormFeedback>{errors.username}</FormFeedback>
										</FormGroup>
									</Col>}
								</Row>
								<Row>
									<Col className="pr-1" md="6">
										<FormGroup>
											<label>Mobile Number</label>
											<Input
												type="text"
												name="mobile_no"
												maxLength={"10"}
												placeholder="Your Mobile Number"
												value={params.mobile_no || ""}
												onChange={handleChange}
												invalid={errors.mobile_no && errors.mobile_no.length > 0 ? true : false}
											/>
											<FormFeedback>{errors.mobile_no}</FormFeedback>
										</FormGroup>
									</Col>

									<Col className="pl-1" md="6">
										<FormGroup>
											<label>Password</label>
											<Input
												autoComplete="new-password"
												type="password"
												name="password"
												placeholder="Password"
												value={params.password || ""}
												onChange={handleChange}
												invalid={errors.password && errors.password.length > 0 ? true : false}
											/>
											<FormFeedback>{errors.password}</FormFeedback>
										</FormGroup>
									</Col>
								</Row>
								<Row>
									<Col className="pr-1" md="6">
										<FormGroup>
											<Label for="profile_pic">Photo Upload</Label>
											<CustomInput
												type="file"
												id="profile_pic"
												name="profile_pic"
												accept="image/*"
												onChange={(e) => {
													params.profile_pic = e.target.files[0];
												}} />
										</FormGroup>
									</Col>
									<Col className="pl-1" md="6">
										<FormGroup>
											<Label for="status">Status</Label>
											<Input
												type="select"
												name="status"
												id="status"
												value={params.status}
												onChange={handleChange}
												invalid={errors.status && errors.status.length > 0 ? true : false}
											>
												{
													STATUS_LIST.map(status => (
														<option key={status.id} value={status.id}>{status.title}</option>
													))
												}
											</Input>
											<FormFeedback>{errors.status}</FormFeedback>
										</FormGroup>
									</Col>
								</Row>
								<Row>
									<Col className="pr-1" md="6">
										<FormGroup>
											<label>Email (Optional)</label>
											<Input
												type="text"
												name="email"
												placeholder="Your Email"
												value={params.email || ""}
												onChange={handleChange}
												invalid={errors.email && errors.email.length > 0 ? true : false}
											/>
											<FormFeedback>{errors.email}</FormFeedback>
										</FormGroup>
									</Col>
									{isDistrictOfficer &&
										<Col className="pr-3" md="6">
											<FormGroup>
												<Label for="district_id">District</Label>
												<Input
													type="select"
													name="district_id"
													id="district_id"
													value={params.district_id}
													onChange={handleChange}
													invalid={errors.district_id && errors.district_id.length > 0 ? true : false}
												>
													<option value={-1}>Select District</option>
													{
														districts.map(district => (
															<option key={district.id} value={district.id}>{district.name}</option>
														))
													}
												</Input>
												<FormFeedback>{errors.district_id}</FormFeedback>
											</FormGroup>
										</Col>
									}
									{isDepartmentOfficer &&
										<Col className="pr-3" md="6">
											<FormGroup>
												<Label for="department_id">Departments</Label>
												<Input
													type="select"
													name="department_id"
													id="department_id"
													value={params.department_id}
													onChange={handleChange}
													invalid={errors.department_id && errors.department_id.length > 0 ? true : false}
												>
													<option value={-1}>Select Department</option>
													{
														departments.map(department => (
															<option key={department.id} value={department.id}>{department.name}</option>
														))
													}
												</Input>
												<FormFeedback>{errors.department_id}</FormFeedback>
											</FormGroup>
										</Col>
									}
								</Row>
								<Row>
									<div className="update ml-auto mr-auto">
										<Button
											className="btn-round"
											color="primary"
											type="submit"
										>
											Submit
										</Button>
									</div>
								</Row>
							</Form>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</div>
	)
}

export default ManageUser